module.exports = __webpack_public_path__ + "static/media/iconfont.57c443a2.eot";